var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPartner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_partner_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_partner_svg__cls-1{fill:#ccc;fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_partner_svg__cls-1",
    d: "M30.98 39.99l8.72-2.48V34.9l-8.72 2.47v2.62zM30.98 48.46h8.72v-4.25l-8.72 2.47v1.78zM30.98 44.64l8.72-2.47v-2.61l-8.72 2.47v2.61zM30.98 12.96v8.41l7.59-2.15-7.59-6.26zM20.3 48.46h8.71v-35.5l-8.71 7.2v28.3zM30.98 30.68l8.72-2.47v-2.62l-8.72 2.48v2.61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_partner_svg__cls-1",
    d: "M0 0v60h60V0H0zm44.48 50.56H15.52v-2.1h2.68V19.17L30 9.43l11.8 9.74v29.29h2.68v2.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon_partner_svg__cls-1",
    d: "M30.98 26.02l8.72-2.47v-2.61l-8.72 2.47v2.61zM30.98 35.33l8.72-2.47v-2.61l-8.72 2.47v2.61z"
  })));
}
export default SvgIconPartner;